import axios from 'axios';
const CONTROLLER_PATH = 'DeprecatedIncident';
class DeprecatedIncidentService {
    //CREATE
    /*
    create(service) {
        return axios.post(CONTROLLER_PATH, service).then((response) => response.data);
    }
    */
    //READ
    get(id, urlParameters, requestId) {
        return axios.get(CONTROLLER_PATH + (id ? '/' + id : ''), {params: urlParameters, requestId: requestId}).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }
    getAgeing() {
        return axios.get(CONTROLLER_PATH + '/ageing').then((response) => response.data);
    }

    //UPDATE
    /*
    update(service) {
        return axios.put(CONTROLLER_PATH + '/' + service.id, service).then((response) => response.data);
    }
    */

    //DELETE
    /*
    delete(id) {
        return axios.delete(CONTROLLER_PATH + '/' + id).then(() => {});
    }
    */
}

export default new DeprecatedIncidentService();
